import { render, staticRenderFns } from "./RightDrawer.vue?vue&type=template&id=15bedcf2&"
import script from "./RightDrawer.vue?vue&type=script&lang=js&"
export * from "./RightDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports